module.exports = __webpack_public_path__ + "img/rocking-chairs-05.f121a3c1.jpeg";